import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Wrapper } from '@zoopla/layout/wrapper';

const Layout = styled(Wrapper)(({ theme: { mq, spacing } }) => {
    return css`
        margin: 0 auto;
        padding: 0;

        ${mq.medium} {
            padding: 0 ${spacing['16px']};
        }

        ${mq.large} {
            padding: 0 ${spacing['32px']};
            display: flex;
            flex-direction: column;
        }
    `;
});

export const Page = Layout.withComponent('main');

export const HomeValueAndPropertySearchWrapper = styled('div')(
    ({ theme: { mq, spacing } }) => {
        return css`
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0 ${spacing['16px']};
            margin-top: ${spacing['32px']};

            ${mq.medium} {
                padding: 0;
                flex-direction: row;
                margin-top: ${spacing['104px']};
            }

            ${mq.large} {
                flex-direction: row;
                margin-top: ${spacing['64px']};
            }
        `;
    }
);
